import styled from 'styled-components';

import { getSpace, getColor, getTextType } from '@stylesheets/tools';

import { getGradientOutline } from '../../wishes.style';

const StyledWishLocation = styled.div`
  position: relative;
  width: 100%;
  color: black;

  &__container {
  }

  &__consent-link {
    margin-top: ${getSpace('xxs')};
  }

  &__consent-details {
    background: transparent;
    margin-top: ${getSpace('xxs')};
    appearance: none;
    border: 0;
    padding: 0;
    cursor: pointer;
  }

  &__consent-btn {
    margin-top: ${getSpace('xs')};
  }

  // React select overwrites
  .react-select__control {
    border: none;
    cursor: pointer;
  }

  .react-select__indicators {
    display: none;
  }

  .react-select__input-container,
  .react-select__value-container {
    margin: 0;
    padding: 0;
  }

  .react-select__value-container {
    position: relative;
    border: none;
    width: 100%;
    background: ${getColor('white')};
    padding: ${getSpace('xxxs')} ${getSpace('xxs')};
    ${getTextType('subline')};
    border: 2px solid ${getColor('black')};
    border-radius: 4px;
    text-transform: uppercase;
    overflow: visible;
  }

  .react-select__value-container--has-value {
    border-color: transparent;
    ${getGradientOutline()};

    &:before {
      z-index: -1;
      inset: -3px;
    }
  }

  .react-select__indicator {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export default StyledWishLocation;
